export enum PaymentMethods {
  CARD_OR_SEPA = 0,
  INVOICE = 1,
}

export enum PaymentMethodChargebeeTypes {
  CREDIT_CARD = 'credit-card',
  SEPA = 'sepa',
  INVOICE = 'bank-transfer',
}
